/** Copy the visible bytes into an owned buffer accepted by Blob and Web Crypto. */
export function toArrayBuffer(bytes: Uint8Array): ArrayBuffer {
  return new Uint8Array(bytes).buffer;
}
